export const fontFamily = [
            {
                id: "思源黑体", name: "思源黑体"
            },
            {
                id: "微软雅黑", name: "微软雅黑"
            },
            {
                id: "Teng2", name: "Teng2"
            },
        ];
export const fontStyle = [
            {
                id: "normal,bold", name: "加粗"
            },
            {
                id: "italic,normal", name: "倾斜"
            },
        ];
export const labelPosition = [
                {
                    id: "top", name: "上"
                },
                {
                    id: "inside", name: "中"
                },
                {
                    id: "insideBottom", name: "下"
                },
        ]
export const legendPosition = [
    {
        id: "0,auto,auto,0", name: "左上",},
        {id: "0,auto,auto,center", name: "上",},
        {id: "0,0,auto,auto", name: "右上",},
        {id: "auto,auto,0,0", name: "左下",},
        {id: "auto,auto,0,center", name: "下",},
        {id: "auto,0,0,auto", name: "右下",},
    
]
export const tooltipTrigger = [
    {id: "item", name: "数据项图形触发"},
    {id: "axis", name: "坐标轴触发"},
    {id: "none", name: "不会触发"},
]
export const tooltipTriggerOn = [
    {id: "mousemove", name: "鼠标移动"},
    {id: "click", name: "点击"},
    {id: "mousemove|click", name: "鼠标移动和点击"},
]
export const borderStyle = [
    {id: "solid", name: "实线"},
    {id: "dashed", name: "虚线"},
]